
import { SiriusBaseComponent } from 'sirius-framework';
import { DocumentPopupService } from './documentPopup.service';
import { DocumentPopupModel } from './documentPopup.model';
import { Component, Input, Output, EventEmitter } from '@angular/core'; 

declare const $: any;

@Component({
    selector: 'document-popup',
    templateUrl: './documentPopup.component.html',
    styleUrls: ['./documentPopup.component.css']
})

export class DocumentPopupComponent extends SiriusBaseComponent<DocumentPopupModel> {
    @Input() opened: boolean = false;
    @Input() visibleCancelBtn: boolean = true; 
    private _documentID: string; 
    @Input() set documentID(value: string) {
        this._documentID = value;
        setTimeout(() => {
            $('#backBtnControlC').trigger("click");
        }, 200);
    }
    @Output() onClose = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() onScrollEnd = new EventEmitter();
    @Output() onOverlayClicked = new EventEmitter();

    isScrollEnd: boolean = false;
    @Input() title: string = "Title";
    scrollTop: any;
    clientHeight: any;
    scrollHeight: any;
    isFirstCall: boolean = true;
     

    get documentID(): string {
        return this._documentID;

    }

    constructor(private service: DocumentPopupService) {
        super();

    }

    onDocLoad() {
        $('#backBtnControlC').trigger("click"); 
    }

    OnInit() {
        $('html').addClass('dont-move-back'); 
    }

    public close(e: any) {
        this.onClose.emit(e);
        $('html').removeClass('dont-move-back');
    }

    public open() {

    }

  scroll(e: Event) {
    //TODO Volkan: Kontrol et.
        var scrollTop = (e.srcElement as HTMLElement).scrollTop;
        var clientHeight = (e.srcElement as HTMLElement).clientHeight;
        var scrollHeight = (e.srcElement as HTMLElement).scrollHeight;

        //close ve cancel eventenden sonra tekrar çalışıyor.
        if ((scrollTop + clientHeight) >= scrollHeight && this.isFirstCall) {
            this.onScrollEnd.emit(this.title);
            this.isScrollEnd = true;
        }
        this.isFirstCall = true;
    }

    closeDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onClose.emit(this.title);
        this.isFirstCall = false;

    }

    cancelDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onCancel.emit(this.title);
        this.isFirstCall = false;
    }

    clickOverlay(e: Event) {
        this.onOverlayClicked.emit(this.title);
    }
}
